import { IndexSummary } from '../models/api/view/claim/documentation/index-system/index-summary';
import { IndexReport } from '../models/api/view/claim/documentation/index-system/index-report';

export class IndexSystemMapper {
  static mapIndexType(indexType: string, status?: string): string {
    if (status === 'W') {
      return 'Lag period active';
    }

    switch (indexType) {
      case 'I':
        return 'Initial';
      case 'R':
        return 'Replacement';
      case 'S':
        return 'Re-Search';
      case 'U':
        return 'Update';
      case 'Z':
        return 'Update, Replacement';
      case 'A':
        return 'Auto Update';
      default:
        return 'Unknown';
    }
  }

  static mapSearch(search: string): string {
    return search === 'Y' ? 'Yes' : search === 'N' ? 'No' : '';
  }

  static mapRequestType(requestType: string): string {
    return requestType === 'M' ? 'Manual' : 'Automatic';
  }

  static mapStatus(status: string): string {
    switch (status) {
      case 'J':
      case 'F':
      case 'P':
        return 'Pending';
      case 'S':
        return 'Sent';
      case 'R':
        return 'Received';
      case 'W':
        return 'Wait';
      default:
        return 'Unknown';
    }
  }

  static mapResult(matches: number | null): string {
    if (matches === null || matches === undefined) return '';
    if (matches === 0) return 'No Match';
    if (matches === 1) return '1 Match';
    return `${matches} Matches`;
  }

  static getMatchReason(
    matches: number | null,
    originalMatchReason: string,
  ): string {
    if (matches !== null && matches > 1) {
      return 'Multiple';
    }
    return originalMatchReason || '';
  }

  static mapSummaryRow(row: IndexSummary): {
    indexType: string;
    search: string;
    requestType: string;
    status: string;
    result: string;
    matchReason: string;
  } {
    return {
      indexType: this.mapIndexType(row.indexType, row.status),
      search: this.mapSearch(row.search),
      requestType: this.mapRequestType(row.requestType),
      status: this.mapStatus(row.status),
      result: this.mapResult(row.matches),
      matchReason: this.getMatchReason(row.matches, row.matchReason),
    };
  }

  static mapReportRow(row: IndexReport): {
    reportType: string;
    submitType: string;
    matchCount: string;
    matchReason: string;
  } {
    return {
      reportType: this.mapIndexType(row.reportType),
      submitType: this.mapRequestType(row.submitType),
      matchCount: this.mapResult(row.matchCount),
      matchReason: this.getMatchReason(row.matchCount, row.matchReason),
    };
  }
}
